import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialBookingDetails } from '../initialState'

const bookingCreationSlice = createSlice({
  name: 'bookingCreation',
  initialState: initialBookingDetails,
  reducers: {
    updateBookingResult: (state: any, action: PayloadAction<any>) => {
      return action.payload
    },
  },
})
export const bookingCreationAction = bookingCreationSlice.actions
export default bookingCreationSlice
